<template>
  <v-card
    class="mt-4"
    style="background-color:transparent"
    flat
  >

    <!-- Should a partner logo or a onechart logo be shown-->
    <v-layout row>
      <v-layout
        column
        justify-center
      >

        <div
          style="margin: 0 auto;"
          class="logo"
        >

          <img
            style="width:300px"
            :src="correctLogoURL"
            alt=""
          >

        </div>
        <v-layout
          class="mt-2"
          v-if="showCobranding"
          justify-center
        >
          <span style="opacity:0.5; font-size:10;">Powered by OneChart Health</span>
        </v-layout>

        <v-layout
          v-else
          class="mt-2"
          justify-center
        >
          <span
            class="text-xs-center"
            style="opacity:0.5; font-size:10; width:300px;"
          >Securely store, access, and share your health information anywhere</span>
        </v-layout>

      </v-layout>
    </v-layout>

  </v-card>
</template>

<style lang="scss" scoped>
$font: sans-serif;
$color: #1565c0;
$gender: #666;
$birthdate: #999;
$addr: #1565c0;
$background-gray: #eee;

.logo {
  display: flex;
  align-items: center;
  font-size: 28px;
  color: 'primary';
  // padding: 10px 24px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 7px;
  font-weight: 300;
  .logo-icon {
    margin-right: 5px;
    font-size: 40px;
  }
}

.contentDivider {
  margin-top: 20px;
  margin-bottom: 20px;
  height: 1px;
  width: 100%;
  background-color: #dddddd;
}
</style>
<script>
import Avatar from '@/core/components/Avatar'

export default {
  name: 'OnePatientCard',
  components: {
    Avatar
  },
  props: {
    recordShare: {
      type: Boolean,
      default: false
    },
    providerLanding: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showCobranding: false
    }
  },
  computed: {
    correctLogoURL() {
      return 'https://storage.googleapis.com/onechart-assets/logos/login/default_normalized.png'
    },
    standardLogo() {
      return 'https://storage.googleapis.com/onechart-assets/logos/login/default_normalized.png'
    }
  },
  methods: {
    textSwitch() {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/BrandingHeaderCard.vue